import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { isEqual } from 'lodash';
import { Observable } from 'rxjs';
import {
  map,
  tap,
  publishReplay,
  refCount,
  distinctUntilChanged,
} from 'rxjs/operators';
import { selectUsers } from '../state/reducer';
import { LoadUsers } from '../state/users/actions';
import { UsersState } from '../state/users/state';

@Injectable({
  providedIn: 'root',
})
export class UsersFacade {
  readonly usersState$: Observable<UsersState>;

  constructor(private store: Store<Record<string, unknown>>) {
    this.usersState$ = store.pipe(
      select(selectUsers),
      map((usersState) => {
        if (usersState.error) {
          throw new Error(usersState.error);
        } else {
          return usersState;
        }
      }),
      tap((usersState) => this.loadUsers(usersState)),
      distinctUntilChanged(isEqual),
      publishReplay(1),
      refCount()
    );
  }

  loadUsers(state: UsersState) {
    if (!state.error && !state.loading && !state.loaded) {
      setTimeout(() => {
        this.store.dispatch(new LoadUsers());
      }, 1);
    }
  }
}
